import { createContext, useContext } from 'react'

import type { ConsoleSnapshotReadModel } from '../api/models'

export type ConsoleConnectionStatus = 'connecting' | 'live' | 'reconnecting' | 'offline' | 'stale'

export type ConsoleViewState = {
  snapshot: ConsoleSnapshotReadModel
  connectionStatus: ConsoleConnectionStatus
}

export const ConsoleViewContext = createContext<ConsoleViewState | null>(null)

export function useConsoleView(): ConsoleViewState {
  const value = useContext(ConsoleViewContext)
  if (!value) throw new Error('ConsoleSnapshotProvider is required')
  return value
}
